<template>
  <div>
    <header class="section pass-header" :style="{ background: success && (info.bg_color ? info.bg_color : '#f5d784') }">
      <div class="container">
        <div class="columns header is-vcentered is-hidden-mobile">
          <div class="column">
            <h1 class="title is-1 is-spaced">{{ info.title }}</h1>
            <p class="subtitle has-text-weight-medium">
              {{ info.desc }}
            </p>
          </div>
          <div class="column">
            <template v-if="info && info.video_url">
              <div class="image is-16by9">
                <div class="iframe-wrap" v-html="info.video_url"></div>
              </div>
            </template>
            <template v-else-if="info.image">
              <div class="image">
                <img alt="..." :src="info.image" />
              </div>
            </template>
          </div>
        </div>
        <div class="columns header is-hidden-tablet">
          <div class="column">
            <h1 class="title is-1 is-spaced has-text-white">
              Play Pass &amp; Punch Pass
            </h1>
            <p class="subtitle has-text-weight-medium has-text-white">
              {{ info.desc }}
            </p>
          </div>
        </div>
      </div>
    </header>
    <section class="section price">
      <div class="container">
        <div class="columns is-centered is-vcentered">
          <div class="column is-8-tablet">
            <div>
              <div class="notification is-danger is-light has-text-weight-medium mb-4">
                <div class="ng-star-inserted">
                  You can now buy the punch pass online and pick it up at the
                  store. These punch passes are great for holiday gifts! 😊
                </div>
              </div>
            </div>
            <div>
              <table class="table is-striped is-hoverable is-fullwidth">
                <thead class="has-background-primary has-text-centered">
                  <tr>
                    <th scope="col" class="has-text-white">Age</th>
                    <th scope="col" id="head" class="has-text-white">0-2</th>
                    <th scope="col" id="head" class="has-text-white">3+</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in items" :key="index">
                    <th scope="row">{{ item.title }}</th>
                    <td>
                      <div class="flex justify_content_c">
                        <div class="flex" v-if="item.activity_discount1 && item.activity_discount1.discount">
                          <!-- 有折扣 -->
                          <div class="discount_price">${{ (Number(item.price1) * (100 -
                            item.activity_discount1.discount)
                            /
                            100).toFixed(2) }}</div>
                          <div class="org_price">${{ item.price1 }}</div>
                          <div class="discount">-{{ item.activity_discount1.discount }}%</div>
                        </div>
                        <div v-else>
                          {{ item.price1 }}
                        </div>
                        <el-button v-if="item.sale_online == 1" @click="buy(item, 1, index)"
                          class="is-primary is-underlined has-text-weight-medium red_btn ml4"
                          :loading="item.loading">Buy</el-button>
                      </div>
                    </td>
                    <td>
                      <div class="flex justify_content_c">
                        <div class="flex" v-if="item.activity_discount2 && item.activity_discount2.discount">
                          <!-- 有折扣 -->
                          <div class="discount_price">${{ (Number(item.price2) * (100 -
                            item.activity_discount2.discount)
                            /
                            100).toFixed(2) }}</div>
                          <div class="org_price">${{ item.price2 }}</div>
                          <div class="discount">-{{ item.activity_discount2.discount }}%</div>
                        </div>
                        <div v-else>
                          {{ item.price2 }}
                        </div>
                        <el-button v-if="item.sale_online == 1" @click="buy(item, 2, index)"
                          class="is-primary is-underlined has-text-weight-medium red_btn ml4"
                          :loading="item.loading1">Buy</el-button>
                      </div>
                    </td>
                  </tr>
                  <tr class="ng-star-inserted" v-for="(item, index) in price_desc" :key="`tr_${index}`">
                    <td colspan="3" class="has-text-justified">
                      <strong>{{ item.title }}:</strong> {{ item.desc }}.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <el-dialog v-if="dialogVisible" title="Payment method" :visible.sync="dialogVisible" width="1000px"
      :before-close="handleClose" :append-to-body="true" :close-on-click-modal="false">
      <el-row :gutter="10" style="margin-top: 10px">
        <el-col :lg="12" :md="12" :sm="24" :xl="12" :xs="24">
          <el-form ref="form" :rules="rules" :model="form" label-width="200px">
            <el-form-item prop="quantity" label="quantity: ">
              <el-input-number size="medium" v-model="form.quantity" placeholder="quantity" :min="1" :precision="0"
                @change="quantity_change" />
            </el-form-item>
            <el-form-item label="Card Number：" prop="card_number">
              <el-input v-model="form.card_number" placeholder="Card Number" size="medium" />
            </el-form-item>
            <el-form-item label="Expiration Date：" prop="month">
              <!-- form.expiration_date {{ form.expiration_date}} -->
              <!-- <el-date-picker v-model="form.expiration_date" type="month" format="MM/yyyy" placeholder="select"
                value-format="yyyy-MM" style="width: 100%" :picker-options="pickerOptions">
              </el-date-picker> -->
              <div style="display: flex">
                <el-form-item label="" prop="month">
                  <el-select v-model="form.month" placeholder="Month" @change="changeMonthYear">
                    <el-option v-for="month in 12" :key="month" :label="month" :value="month"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="" prop="year" style="margin-left: 10px">
                  <el-select v-model="form.year" placeholder="Year" @change="changeMonthYear">
                    <el-option v-for="year in yearOptions" :key="year" :label="year" :value="year"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="tips">{{ tips }}</div>

            </el-form-item>
            <el-form-item label="Security code(CVV/CVC)：" prop="card_code" label-width="200px">
              <el-input v-model="form.card_code" placeholder="Security code(CVV/CVC)" size="medium" maxlength="4"/>
            </el-form-item>
            <el-form-item prop="phone" label="Phone：">
              <el-input size="medium" v-model="form.phone" @input="formatPhoneNumberInfo" placeholder="(201)555-0123"
                maxlength="13" />
            </el-form-item>
            <el-form-item prop="email" label="Email：">
              <el-input size="medium" v-model="form.email" placeholder="Email" />
            </el-form-item>
            <el-form-item label="First Name：" prop="first_name">
              <el-input v-model="form.first_name" placeholder="First Name" size="medium" />
            </el-form-item>
            <el-form-item label="Last Name：" prop="last_name">
              <el-input v-model="form.last_name" placeholder="Last Name" size="medium" />
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :lg="12" :md="12" :sm="24" :xl="12" :xs="24">
          <div class="LEVEL-DETAIL" :style="`background: #F3CB61`">
            <div class="level-name">{{ item && item.title }}</div>
            <div class="level-age">{{ type == 1 ? '0-2' : '3+' }} Age</div>
            <div class="HR"></div>
            <div v-if="type == 1" class="flex space-between">
              <div class="flex" v-if="item.activity_discount1 && item.activity_discount1.discount">
                <!-- 有折扣 -->
                <div class="discount_price">${{ (Number(item.price1) * (100 -
                  item.activity_discount1.discount)
                  /
                  100).toFixed(2) }}</div>
                <div class="org_price">${{ item.price1 }}</div>
                <div class="discount">-{{ item.activity_discount1.discount }}%</div>
                <div> / pass（{{ form.quantity }}）</div>
              </div>
              <div v-else>
                ${{ item.price1 }} / pass（{{ form.quantity }}）
              </div>
              <!-- price -->
              <div class="strong">
                {{ subtotal }}
              </div>
            </div>
            <div v-if="type == 2" class="flex space-between">
              <div class="flex" v-if="item.activity_discount2 && item.activity_discount2.discount">
                <!-- 有折扣 -->
                <div class="discount_price">${{ (Number(item.price2) * (100 -
                  item.activity_discount2.discount)
                  /
                  100).toFixed(2) }}</div>
                <div class="org_price">${{ item.price2 }}</div>
                <div class="discount">-{{ item.activity_discount2.discount }}%</div>
                <div> / pass（{{ form.quantity }}）</div>
              </div>
              <div v-else>
                ${{ item.price2 }} / pass（{{ form.quantity }}）
              </div>
              <div class="strong">
                {{ subtotal }}
              </div>
            </div>
            <div class="HR"></div>
            <div v-if="type == 1">
              <div class="flex space-between">
                <span>Subtotal</span>
                <span>
                  ${{ subtotal }}
                </span>
              </div>
              <div class="flex space-between">
                <span>Taxes</span>
                <span>
                  ${{ tax }}
                </span>
              </div>
            </div>
            <div v-if="type == 2">
              <div class="flex space-between">
                <span>Subtotal</span>
                <span>
                  ${{ subtotal }}
                </span>
              </div>
              <div class="flex space-between">
                <span>Taxes</span>
                <span>
                  ${{ tax }}
                </span>
              </div>
            </div>
            <div class="HR"></div>
            <div class="flex space-between">
              <span>Total</span>
              <span>
                ${{ getTotal() }}
              </span>
            </div>
          </div>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Close</el-button>
        <el-button type="primary" @click="toBuy" :loading="loading">Buy</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { playPunchList, payInfo } from "@/server/api.js";
import store from "@/store";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      expiration: '',
      items: [],
      price_desc: [],
      info: {},
      success: false,
      dialogVisible: false,
      yearOptions: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      form: {
        quantity: 1,
        card_number: "",
        expiration_date: "",
        card_code: "",
        email: "",
        first_name: "",
        last_name: "",
      },
      rules: {
        quantity: [
          {
            required: true,
            trigger: "blur",
            message: "Quantity is required.",
          },
        ],
        card_number: [
          {
            required: true,
            trigger: "blur",
            message: "Card Number is required.",
          },
        ],
        month: [
          {
            required: true,
            trigger: "change",
            message: "Month is required.",
          },
        ],
        year: [
          {
            required: true,
            trigger: "change",
            message: "Year is required.",
          },
        ],
        card_code: [
          {
            required: true,
            trigger: "blur",
            message: "Security code(CVV/CVC) is required.",
          },
        ],
        phone: [
          {
            required: true,
            trigger: "blur",
            message: "Please input phone.",
          },
        ],
        email: [
          {
            required: true,
            type: "email",
            trigger: "blur",
            message: "Please input correct email address.",
          },
        ],
        first_name: [
          {
            required: true,
            trigger: "blur",
            message: "First Name is required.",
          },
        ],
        last_name: [
          {
            required: true,
            trigger: "blur",
            message: "Last Name is required.",
          },
        ],
      },
      type: null,
      index: null,
      item: null,
      loading: false,
      subtotal:0,
      tax:0,
      total:0,
      tips: null
    };
  },
  computed: {
    config() {
      return store.state.global.configList || {};
    },
  },
  created() {
    var year = (new Date()).getFullYear();
    var yearOptions = [];
    for(let i = 0; i <= 20; i++) {
      yearOptions.push(year + i)
    }
    this.yearOptions = yearOptions;
    this.getInfo();
  },
  methods: {
    changeMonthYear() {
      if(this.form.month && this.form.year) {
        var expiration_date = this.form.year + '-' + (this.form.month > 9 ? this.form.month : `0${this.form.month}`);
          var date = moment(new Date()).format('YYYY-MM');
          // 选择的日期
          var date1 = new Date(expiration_date + '-01T00:00:00');
          // 今天的日期
          var date2 = new Date(date + '-01T00:00:00');
          if (date1 < date2) {
            this.tips = 'expiration date error';
          } else {
            this.tips = null;
          }
      } else {
        this.tips = null;
      }
    },
    formatPhoneNumberInfo(value) {
      const digits = value.replace(/\D/g, '');
      if (digits.length > 6) {
        this.form.phone = `(${digits.slice(0, 3)})${digits.slice(3, 6)}-${digits.slice(6)}`;
      } else if (digits.length > 3 && digits.length <= 6) {
        this.form.phone = `(${digits.slice(0, 3)})${digits.slice(3)}`;
      } else {
        this.form.phone = digits;
      }
    },
    quantity_change(value){
      console.log(value)
      this.getTotal()
    },
    getTotal() {
      if(this.type == 1) {
        if (this.item.activity_discount1 && this.item.activity_discount1.discount) {
          this.subtotal = ((Number(this.item.price1) * (100 -
            this.item.activity_discount1.discount)
            /
            100).toFixed(2) * this.form.quantity).toFixed(2);
        } else {
          this.subtotal = (this.item.price1 * this.form.quantity).toFixed(2);
        }
        this.tax = (this.subtotal * Number(this.config.tax_rate) / 100).toFixed(2)
        this.total = (Number(this.subtotal) + Number(this.tax)).toFixed(2);
        return this.total;
      }
      if(this.type == 2) {
        if (this.item.activity_discount2 && this.item.activity_discount2.discount) {
          this.subtotal = ((Number(this.item.price2) * (100 -
            this.item.activity_discount2.discount)
            /
            100).toFixed(2) * this.form.quantity).toFixed(2)
        } else {
          this.subtotal = (this.item.price2 * this.form.quantity).toFixed(2);
        }
        this.tax = (this.subtotal * Number(this.config.tax_rate) / 100).toFixed(2)
        this.total = (Number(this.subtotal) + Number(this.tax)).toFixed(2);
        return this.total;
      }
    },
    async getInfo() {
      try {
        const { status, data } = await playPunchList({});
        if (status == 0) {
          this.price_desc = data.price_desc;
          data.items.map((item) => (item.loading = false));
          this.items = data.items;
          this.info = data.info;
          this.success = true;
          setTimeout(() => {
            var iframe = document.getElementsByTagName("iframe");
            for (let i = 0; i <= iframe.length - 1; i++) {
              iframe[i].style.width = "100%";
              iframe[i].style.height = "100%";
            }
          }, 0);
        }
      } catch (error) { }
    },
    handleClose() {
      this.dialogVisible = false;
      this.form = {
        quantity: 1,
        card_number: "",
        expiration_date: "",
        card_code: "",
        phone: "",
        email: "",
        first_name: "",
        last_name: "",
        company: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        country: ""
      }
    },
    // 直接跳转到支付页面
    // async buy(item, type, index) {
    //   var items = JSON.parse(JSON.stringify(this.items));
    //   items.map((citem, cindex) => {
    //     if (cindex == index) {
    //       if(type==1) {
    //         citem.loading = true;
    //       } else {
    //         citem.loading1 = true;
    //       }
    //     }
    //     return citem;
    //   });
    //   this.items = items;
    //   const { status, data } = await payInfo({
    //     product_type: 1,
    //     product_id: item.id,
    //     pay_way: type,
    //   });
    //   if (status === 0) {
    //     // window.open(data.pay_url);
    //     const a = document.createElement('a');
    //     a.href = data.pay_url;
    //     document.body.appendChild(a);
    //     a.click();
    //     document.body.removeChild(a);
    //   } else {
    //     this.$message.error("获取失败");
    //   }
    //   var items = JSON.parse(JSON.stringify(this.items));
    //   items.map((citem, cindex) => {
    //     if (cindex == index) {
    //       if(type==1) {
    //         citem.loading = false;
    //       } else {
    //         citem.loading1 = false;
    //       }
    //     }
    //     return citem;
    //   });
    //   this.items = items;
    // },
    // buy
    async buy(item, type, index) {
      this.type = type;
      this.index = index;
      this.item = item;
      this.dialogVisible = true;
    },
    async toBuy() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          var obj = {};

          obj.expiration_date = this.form.year + '-' + (this.form.month > 9 ? this.form.month : `0${this.form.month}`);
          var date = moment(new Date()).format('YYYY-MM');
          // 选择的日期
          var date1 = new Date(obj.expiration_date + '-01T00:00:00');
          // 今天的日期
          var date2 = new Date(date + '-01T00:00:00');
          if (date1 < date2) {
            this.$message.warning("expiration date error");
            this.loading = false;
            return
          }

          if (this.type == 1 && this.item.activity_discount1 && this.item.activity_discount1.discount) {
            obj.activity_discount_id = this.item.activity_discount1.id
          }
          if (this.type == 2 && this.item.activity_discount2 && this.item.activity_discount2.discount) {
            obj.activity_discount_id = this.item.activity_discount2.id
          }
          const { status, data, msg } = await payInfo({
            product_type: 1,
            product_id: this.item.id,
            pay_way: this.type,
            // quantity: this.form.quantity,
            ...this.form,
            ...obj
          }).catch(err => {
            this.loading = false;
          });
          if (status === 0) {
            this.loading = false;
            this.$message.success("success");
            this.dialogVisible = false;
            this.handleClose()
            // window.open(data.pay_url);
            // const a = document.createElement('a');
            // a.href = data.pay_url;
            // document.body.appendChild(a);
            // a.click();
            // document.body.removeChild(a);
          } else {
            this.loading = false;
            this.$message.error(msg);
          }
        }
      })
    }
  },
};
</script>
<style scoped>
.pass-header {
  margin-top: 50px;
}

.hero-body,
.section {
  padding: 3rem 1.5rem;
}

.container {
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  width: auto;
}

.columns {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -1.5rem;
}

.columns:last-child {
  margin-bottom: -1.5rem;
}

.columns:not(:last-child) {
  margin-bottom: calc(1.5rem - 1.5rem);
}

.columns.is-vcentered {
  align-items: center;
}

.column {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 1.5rem;
  box-sizing: border-box;
}

.title {
  color: #363636;
  font-family: Rubik, sans-serif;
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.125;
}

.block:not(:last-child),
.box:not(:last-child),
.breadcrumb:not(:last-child),
.content:not(:last-child),
.highlight:not(:last-child),
.level:not(:last-child),
.message:not(:last-child),
.notification:not(:last-child),
.pagination:not(:last-child),
.progress:not(:last-child),
.subtitle:not(:last-child),
.table-container:not(:last-child),
.table:not(:last-child),
.tabs:not(:last-child),
.title:not(:last-child) {
  margin-bottom: 1.5rem;
}

.title.is-1 {
  font-size: 3rem;
}

.subtitle {
  color: #757763;
  font-family: Quicksand, sans-serif;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.25;
}

.subtitle,
.title {
  word-break: break-word;
}

.has-text-weight-medium {
  font-weight: 500 !important;
}

img,
video {
  height: auto;
  max-width: 100%;
}

.image {
  display: block;
  position: relative;
  height: 340px;
}

.image img {
  display: block;
  height: 100%;
}

img {
  height: auto;
  max-width: 100%;
}

.has-text-weight-medium {
  font-weight: 500 !important;
}

.has-text-white {
  color: #fff !important;
}

.subtitle {
  color: #757763;
  font-family: Quicksand, sans-serif;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.25;
}

.subtitle,
.title {
  word-break: break-word;
}

.columns.is-vcentered {
  align-items: center;
}

.columns.is-centered {
  justify-content: center;
}

.columns:last-child {
  margin-bottom: -1.5rem;
}

.notification {
  background-color: #f5f5f5;
  border-radius: 4px;
  position: relative;
  padding: 1.25rem 2.5rem 1.25rem 1.5rem;
}

.notification.is-danger.is-light {
  background-color: #fceeee;
  color: #bd2327;
}

.notification.is-danger {
  background-color: #de4c50;
  color: #fff;
}

.notification.is-light {
  background-color: #f5f5f5;
  color: rgba(0, 0, 0, 0.7);
}

.has-text-weight-medium {
  font-weight: 500 !important;
}

.mb-4 {
  margin-bottom: 1rem !important;
}

.table {
  background-color: #fff;
  color: #363636;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

.table.is-fullwidth {
  width: 100%;
}

table thead {
  color: #fff;
  text-align: center;
}

.table thead {
  background-color: initial;
}

.has-text-centered {
  text-align: center !important;
}

.has-background-primary {
  background-color: #de4c50 !important;
}

.table td,
.table th {
  border: solid #dbdbdb;
  border-width: 0 0 1px;
  padding: 0.5em 0.75em;
  vertical-align: center;
}

.table th {
  color: #363636;
}

.table th:not([align]) {
  text-align: inherit;
}

.table thead td,
.table thead th {
  border-width: 0 0 2px;
  color: #363636;
}

table th:not([align]) {
  text-align: inherit;
}

.table tbody {
  background-color: initial;
}

table tr td {
  text-align: center;
  align-items: center;
}

strong {
  color: #363636;
  font-weight: 700;
}

a {
  color: #e55f61;
  cursor: pointer;
  text-decoration: none;
}

.is-underlined {
  text-decoration: underline;
}

.has-text-weight-medium {
  font-weight: 500 !important;
}

.has-text-justified {
  text-align: justify !important;
}

@media print,
screen and (max-width: 768px) {
  .pass-header {
    background-image: url(../../assets/img/Kids-Jump.bdf66917305d3a34b885.png);
    background-color: rgba(0, 0, 0, 0.5);
    background-blend-mode: multiply;
    background-position: 50%;
    background-repeat: no-repeat;
  }

  .is-hidden-mobile {
    display: none !important;
  }
}

@media print,
screen and (min-width: 769px) {
  .columns:not(.is-desktop) {
    display: flex;
  }

  .is-hidden-tablet {
    display: none !important;
  }

  .column.is-8-tablet {
    flex: none;
    width: 66.6666666667%;
  }
}

@media screen and (min-width: 1024px) {
  .container {
    max-width: 960px;
  }
}

@media screen and (min-width: 1408px) {
  .container:not(.is-max-desktop):not(.is-max-widescreen) {
    max-width: 1344px;
  }
}

.iframe-wrap {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.red_btn {
  padding: 0px;
  color: #e55f61;
  border: 0px;
  font-family: Quicksand, sans-serif;
  font-size: 16px;
}

.org_price {
  margin-left: 8px;
  text-decoration: line-through;
  font-weight: bold;
  color: black;
}

.discount {
  margin-left: auto;
  background: #e65137;
  color: white;
  margin-left: 8px;
  padding: 0px 6px;
  margin-right: 8px;
}

.flex {
  display: flex;
}

.ml4 {
  margin-left: 4px;
}

.justify_content_c {}

.LEVEL-DETAIL {
  color: #fff;
  padding: 16px;
  border-radius: 10px;
  box-shadow: 9px 9px 19px #c9c9c9, -9px -9px 19px #fff;
  margin-bottom: 10px;
}

.level-name {
  font-size: 28px;
  line-height: 1;
  margin: 0.4em 0;
}

.level-age {
  font-size: 26px;
  line-height: 1;
  margin: 0.8em 0 0.4em 0;
}

.HR {
  margin: 16px -0.25em;
  border: 1px solid;
}

.LEVEL-DETAIL div {
  line-height: 20px;
}

.space-between {
  justify-content: space-between;
}

.strong {
  font-weight: bold;
}
.tips {
  color: red;
  font-size: 12px;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/pricing/pass.vue